<template>
  <el-dialog
    title="查看方案"
    :visible.sync="dialogVisible"
    width="850px"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div v-loading="loading" class="scheme-view-content">
      <el-form label-width="150px" class="view-form">
        <el-form-item label="保险公司">
          <span>{{ schemeInfo.insurance_company || "-" }}</span>
        </el-form-item>

        <el-form-item label="保费计算方式">
          <span>按年计算</span>
        </el-form-item>

        <el-form-item label="保费支付方式">
          <span>{{ formatPayType(schemeInfo.pay_type) }}</span>
        </el-form-item>

        <el-form-item label="年龄限制">
          <div>
            <span>男：{{ formatAgeRange(schemeInfo.ageList, 1) }}</span>
            <br />
            <span>女：{{ formatAgeRange(schemeInfo.ageList, 2) }}</span>
          </div>
        </el-form-item>

        <el-form-item label="邮箱">
          <span>{{ schemeInfo.email || "-" }}</span>
        </el-form-item>

        <el-form-item label="是否自动发送邮件">
          <span>{{ schemeInfo.is_send_email ? "是" : "否" }}</span>
        </el-form-item>

        <el-form-item label="价格方案">
          <div
            v-for="(product, index) in schemeInfo.product_list"
            :key="index"
            class="price-scheme-view"
          >
            <el-card class="scheme-card">
              <div slot="header">
                <span>{{ product.name }}</span>
              </div>

              <div class="scheme-info">
                <p>
                  <strong>死亡伤残责任限额：</strong
                  >{{ product.death_disability_coverage / 10000 || 0 }}万元
                </p>
                <p>
                  <strong>医疗费用责任限额：</strong
                  >{{ product.medical_cost_coverage / 10000 || 0 }}万元
                </p>
              </div>

              <el-table
                :data="product.price_list"
                border
                size="small"
                style="margin-top: 15px"
              >
                <el-table-column label="工种" width="150">
                  <template slot-scope="scope">
                    {{ formatEmployeeType(scope.row.employee_type) }}
                  </template>
                </el-table-column>
                <el-table-column label="年度保费(元)" width="150">
                  <template slot-scope="scope">
                    {{ scope.row.price / 100 || 0 }}
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getEmployerProductList } from "@/api/employer-insurance";

export default {
  name: "SchemeViewDialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    schemeData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      loading: false,
      schemeInfo: {
        insurance_company: "",
        pay_type: [],
        ageList: [],
        email: "",
        is_send_email: false,
        product_list: []
      },
      employeeTypeMap: {
        1: "搬运",
        2: "文员",
        4: "司机"
      }
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    }
  },
  watch: {
    visible(val) {
      if (val && this.schemeData) {
        this.loadSchemeDetail();
      }
    }
  },
  methods: {
    async loadSchemeDetail() {
      if (!this.schemeData.insurance_type) return;

      this.resetSchemeInfo();
      this.loading = true;
      try {
        const res = await getEmployerProductList({
          insurance_type: this.schemeData.insurance_type
        });
        if (res && res.err_code === 0) {
          this.parseSchemeData(res);
        }
      } catch (error) {
        console.error("获取方案详情失败:", error);
        this.$message.error("获取方案详情失败");
      } finally {
        this.loading = false;
      }
    },

    parseSchemeData(res) {
      const { rows, ageList } = res;
      if (rows && rows.length > 0) {
        const firstRow = rows[0];

        this.schemeInfo = {
          insurance_company:
            firstRow.insurance_company ||
            this.schemeData.insurance_company ||
            "",
          pay_type: this.parsePayType(firstRow.pay_type),
          ageList: ageList || [],
          email: firstRow.email || "",
          is_send_email: this.toBoolean(firstRow.is_send_email),
          product_list: []
        };

        // 处理产品列表
        rows.forEach(item => {
          this.schemeInfo.product_list.push({
            name: item.name,
            death_disability_coverage: item.death_disability_coverage,
            medical_cost_coverage: item.medical_cost_coverage,
            price_list: item.price_list || []
          });
        });
      }
    },

    formatPayType(payTypeStr) {
      const typeMap = { 1: "对公支付", 2: "二维码" };
      return (
        this.parsePayType(payTypeStr)
          .map(type => typeMap[type])
          .filter(Boolean)
          .join("、") || "-"
      );
    },

    parsePayType(value) {
      if (Array.isArray(value)) return value.map(Number);
      try {
        const result = JSON.parse(value || "[]");
        return Array.isArray(result) ? result.map(Number) : [];
      } catch (error) {
        return [];
      }
    },

    toBoolean(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },

    formatAgeRange(ageList, gender) {
      if (!ageList || ageList.length === 0) return "-";
      const ageInfo = ageList.find(item => Number(item.gender) === gender);
      return ageInfo ? `${ageInfo.age_lower}-${ageInfo.age_upper}岁` : "-";
    },

    formatEmployeeType(type) {
      return this.employeeTypeMap[type] || "-";
    },

    resetSchemeInfo() {
      this.schemeInfo = {
        insurance_company: "",
        pay_type: [],
        ageList: [],
        email: "",
        is_send_email: false,
        product_list: []
      };
    },

    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.scheme-view-content {
  max-height: 500px;
  overflow-y: auto;
}

.view-form {
  .el-form-item {
    margin-bottom: 15px;
  }
}

.price-scheme-view {
  margin-bottom: 20px;

  .scheme-card {
    border: 1px solid #e6e6e6;
  }

  .scheme-info {
    p {
      margin: 5px 0;
      line-height: 1.5;
    }
  }
}
</style>
